import React,{Component} from "react";

import img from "./images/BG.png";
import Modalmobileapp from "./ModalMobileapp";
import qrlogo from "./images/QR.png";
export default class Home extends Component {
  constructor(props)
  {
      super(props);
      this.state=
      { 
          loadmodal:undefined,
          bodytext:<label>To download and install the app on your device, simply <b> open your device's camera app or a QR code scanner application</b> then <b>Scan the QR Code</b>. Your device's browser will start downloading the file. After successful downloading, browse the <b>'Download' </b>folder of your device and install the app.</label>

  };
  this.handleclick=this.handleclick.bind(true);
}
componentDidMount(){
  this.setState({loadmodal:undefined});
  
}
handleclick=()=>{

  this.setState({loadmodal:<Modalmobileapp  />});

}
    render(){
//      console.log(this.state.loadmodal);
            return(
            <div className="container1">
              <div className="center">
              <img src={img} alt="" style={{marginTop:50,height:"250px",width:"200px"}}/>
{/*}            <div style={{backgroundImage: 'url(${process.env.PUBLIC_URL/images/BG.png)}',width:"100%", height:"100%"}}/>*/}
        {/*}        <div style={{width:"100%",textAlign:"center"}}><button style={{backgroundColor:"#848482",color:"white"}} onClick={this.handleclick} >Download mobile app.</button>*/}
                  <div style={{textAlign:"center",width:"100%",marginTop:5,fontSize:11,fontWeight:"bold"}}>Android Mobile App.</div>
                  <div style={{width:"100%",textAlign:"center",alignSelf:"center"}}><img style={{width:70,height:70}} src={qrlogo} alt=""/></div>
                  <div style={{textAlign:"center",width:"100%",marginTop:5,fontSize:10.5,paddingLeft:150,paddingRight:150}}>{this.state.bodytext}</div>

                </div>

{/*}              </div>
              <div style={{marginTop:"100px",alignSelf:"center"}}>*/}
                  {this.state.loadmodal}
{/*}              </div>                */}
          </div>

            );
        } 
}